import React from 'react';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import NoConversion from './NoConversion';
import ManageConversionForm from './ManageConversionForm';
import BobActionMenu from '../../../components/BobActionMenu';

import * as ConversionActions from '../../../actions/conversionActions';

import * as classes from './BuilderPanel.module.css';

const BuilderPanel = ({
    newConversion,
    selectedConversion,
    setNewConversion,
    ...props
}) => {
    let formRef = {};

    const renderView = () => {
        if (!newConversion && isEmpty(selectedConversion)) {
            return <NoConversion />;
        } else if (selectedConversion || newConversion) {
            return <ManageConversionForm setNewConversion={setNewConversion} formRef={formRef} />;
        }
    };

    return (
        <div>
            <div className={classes.Header}>
                <span className={classes.Title}>
                    Builder
                </span>
                {
                    newConversion || !isEmpty(selectedConversion) ?
                        <span className={classes.Button}>
                            <BobActionMenu
                                type="Conversions"
                                handleResetConversion={() => formRef.handleResetConversion()}
                                handleDeleteConversion={() => formRef.handleDeleteConversion()}
                                isK2aConversion={!isEmpty(selectedConversion) && selectedConversion.conversionType.toLowerCase() === 'key2act'}
                            />
                        </span>
                        :
                        null
                }
            </div>
            {renderView()}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:   state.bob.activeNavCompany,
        customConversions:  state.conversion.customConversions,
        k2aConversions:     state.conversion.k2aConversions,
        selectedConversion: state.conversion.selectedConversion
    };
};

const mapDispatchToProps = {
    ...ConversionActions
};

export default connect(mapStateToProps, mapDispatchToProps)(BuilderPanel);
